import { fetchEquipmentsForAboveESP, fetchEquipmentsForBelowESP, setESPEquipmentsForAbove, setESPEquipmentsForBelow, setShowSchematicDataInMainReport } from "../../../store/calculation/calculation-output/schematicSlice";
import { useAppDispatch } from "../../../store/hooks/StoreHooks";

const useSchematicFacade = () => {
    const dispatch = useAppDispatch();

    const fetchAboveEquipments = () => {
        return dispatch(fetchEquipmentsForAboveESP());
    };

    const fetchBelowEquipments = () => {
        return dispatch(fetchEquipmentsForBelowESP());
    };

    const updateESPEquipmentsForAboveESP = (payload: any) => {
        return dispatch(setESPEquipmentsForAbove(payload));
    };

    const updateESPEquipmentsForBelowESP = (payload: any) => {
        return dispatch(setESPEquipmentsForBelow(payload));
    };

    const updateShowSchematicDataInMainReport = (payload: boolean) => {
        return dispatch(setShowSchematicDataInMainReport(payload));
    };

    return {
        fetchAboveEquipments,
        fetchBelowEquipments,
        updateESPEquipmentsForAboveESP,
        updateESPEquipmentsForBelowESP,
        updateShowSchematicDataInMainReport,
    }
};

export default useSchematicFacade;